// Generated by purs version 0.15.16
import * as API_Search from "../API.Search/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord()(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
    reflectSymbol: function () {
        return "studentId";
    }
})(ordRNTY))()({
    reflectSymbol: function () {
        return "formId";
    }
})(ordRNTY))()({
    reflectSymbol: function () {
        return "documentId";
    }
})(/* #__PURE__ */ Data_Maybe.ordMaybe(ordRNTY)));
var insert = /* #__PURE__ */ Data_Map_Internal.insert(ordRecord);
var insert1 = /* #__PURE__ */ Data_Map_Internal.insert(ordRNTY);
var Expanded = /* #__PURE__ */ (function () {
    function Expanded() {

    };
    Expanded.value = new Expanded();
    return Expanded;
})();
var Collapsed = /* #__PURE__ */ (function () {
    function Collapsed() {

    };
    Collapsed.value = new Collapsed();
    return Collapsed;
})();
var setFormExpanded = function (lookup) {
    return function (expansion) {
        return function (ui) {
            return {
                expandedStudents: ui.expandedStudents,
                search: ui.search,
                teacher: ui.teacher,
                semester: ui.semester,
                expandedForms: insert(lookup)(expansion)(ui.expandedForms)
            };
        };
    };
};
var resetWorkQueueUiState = function (defTeacher) {
    return function (defSemester) {
        return function (ui) {
            return {
                search: ui.search,
                expandedStudents: Data_Map_Internal.empty,
                expandedForms: Data_Map_Internal.empty,
                teacher: Widgets_BetterSelect.setSelected(ui.teacher)(defTeacher),
                semester: Widgets_BetterSelect.setSelected(ui.semester)(defSemester)
            };
        };
    };
};
var preserveCurrentExpansion = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Nothing) {
            return v1;
        };
        if (v instanceof Data_Maybe.Just) {
            var preserve = function (dictOrd) {
                var lookup = Data_Map_Internal.lookup(dictOrd);
                var insert2 = Data_Map_Internal.insert(dictOrd);
                return function (key) {
                    return function (states) {
                        var v2 = lookup(key)(states);
                        if (v2 instanceof Data_Maybe.Nothing) {
                            return insert2(key)(Expanded.value)(states);
                        };
                        if (v2 instanceof Data_Maybe.Just) {
                            return states;
                        };
                        throw new Error("Failed pattern match at Steps.WorkQueue.UIState (line 104, column 27 - line 106, column 25): " + [ v2.constructor.name ]);
                    };
                };
            };
            return {
                search: v1.search,
                teacher: v1.teacher,
                semester: v1.semester,
                expandedStudents: preserve(ordRNTY)(v.value0.studentId)(v1.expandedStudents),
                expandedForms: preserve(ordRecord)(v.value0)(v1.expandedForms)
            };
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.UIState (line 87, column 1 - line 90, column 24): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var initialWorkQueueUiState = /* #__PURE__ */ (function () {
    var teacherSel = {
        deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
        editable: Widgets_BetterSelect.defSelectConfig.editable,
        placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-teacher")),
        allowDeselect: false
    };
    var semesterSel = {
        deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
        editable: Widgets_BetterSelect.defSelectConfig.editable,
        placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-semester")),
        allowDeselect: false
    };
    return {
        expandedStudents: Data_Map_Internal.empty,
        expandedForms: Data_Map_Internal.empty,
        search: Widgets_Search.initSearchState,
        teacher: Widgets_BetterSelect["initSelect$prime"]("teacher")(API_Search.teacherSearchAff)(teacherSel),
        semester: Widgets_BetterSelect["initSelect$prime"]("semester")(API_Search.semesterSearchAff)(semesterSel)
    };
})();
var expandNavigationTarget = function (lookup) {
    return function (ui) {
        return {
            search: ui.search,
            teacher: ui.teacher,
            semester: ui.semester,
            expandedStudents: insert1(lookup.studentId)(Expanded.value)(ui.expandedStudents),
            expandedForms: insert(lookup)(Expanded.value)(ui.expandedForms)
        };
    };
};
export {
    Expanded,
    Collapsed,
    initialWorkQueueUiState,
    resetWorkQueueUiState,
    expandNavigationTarget,
    preserveCurrentExpansion,
    setFormExpanded
};
//# sourceMappingURL=index.js.map
